import {getInputStore} from '@ebexco/components/src/components/Item/InputItem';
import {derived} from '@ebexco/components/src/library';

export const experience = getInputStore('experience', false);
export const experienceClass = derived(experience, ($exp) => $exp ? `cvly-exp-${$exp}` : '');
